// libs
import React from 'react';
//dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
import { GenericIcon } from '@swiggy-private/dls-web-icons/dist/GenericIconWeb';
// components
import Tooltip from '@/components/Tooltip';
// constants
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
import { IconInfo } from '@/constants/icons/svg';
// styles
import styles from './MetricsTile.module.scss';
const MetricsTile = ({ label, metric, tooltip }) => {
    return (React.createElement("div", { className: styles.metricsTile },
        React.createElement("div", { className: styles.metricsTileTitle },
            React.createElement(Text, { variant: DlsFontVariants.body_B1_Bold, color: DlsColorTokens.text_Low_Emphasis }, label),
            tooltip && (React.createElement(Tooltip, { content: tooltip },
                React.createElement(GenericIcon, { Icon: IconInfo, fillColor: DlsColorTokens.text_Low_Emphasis })))),
        React.createElement(Text, { variant: DlsFontVariants.header_H1, color: DlsColorTokens.text_Highest_Emphasis, className: styles.metricsTileInfo }, metric)));
};
export default MetricsTile;
